import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Hero } from "../components/site/Hero";
import { Features, HowItWorks, RewardsSection } from "../components/site/Sections";
import { FaqList } from "../components/site/FaqList";
import { WaitlistForm } from "../components/site/WaitlistForm";
import { api, REF_KEY } from "../lib/api";

export const useRefCapture = () => {
  const [params] = useSearchParams();
  useEffect(() => {
    const r = params.get("ref");
    if (r && /^[A-Za-z0-9]{4,20}$/.test(r)) sessionStorage.setItem(REF_KEY, r.toUpperCase());
  }, [params]);
};

export const useTiers = () => {
  const [tiers, setTiers] = useState([]);
  useEffect(() => { api.get("/public/config").then((r) => setTiers(r.data.tiers)).catch(() => {}); }, []);
  return tiers;
};

export default function Landing() {
  useRefCapture();
  const tiers = useTiers();
  return (
    <div data-testid="landing-page">
      <Hero />
      <Features />
      <HowItWorks />
      <RewardsSection tiers={tiers} />
      <section id="waitlist" className="py-24 md:py-32 border-t border-[#1E281E] relative overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-40" />
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-[1fr_1.1fr] gap-14 items-start">
          <div className="lg:sticky lg:top-28">
            <p className="eyebrow">Early access</p>
            <h2 className="mt-3 text-4xl lg:text-5xl font-bold uppercase tracking-tight">Your Game. Your Data. Your Next Level.</h2>
            <p className="mt-5 text-[#A3ADA3] max-w-md">Register in under a minute. We'll verify your email with a one-time code — no passwords, ever.</p>
            <img src="https://images.unsplash.com/photo-1587385789097-0197a7fbd179?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200" alt="Cricket ball on the pitch" className="mt-10 rounded-2xl border border-[#1E281E] w-full max-w-md aspect-[4/3] object-cover opacity-90" />
          </div>
          <WaitlistForm />
        </div>
      </section>
      <section id="faq" className="py-24 border-t border-[#1E281E]" data-testid="faq-section">
        <div className="max-w-3xl mx-auto px-5">
          <p className="eyebrow">FAQ</p>
          <h2 className="mt-3 text-4xl font-bold uppercase tracking-tight">Questions, Answered.</h2>
          <FaqList limit={6} />
          <Link to="/faq" className="inline-block mt-8 text-[#B7FF3C] hover:underline underline-offset-4" data-testid="faq-see-all">See all questions →</Link>
        </div>
      </section>
    </div>
  );
}
